// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"31d6cfe0","451":"43c677e4","751":"9134687b","795":"61d4c1de","801":"634fd504","867":"7e15d51e","987":"c58b7266"}[chunkId] + ".chunk.css";
};